<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/contos">Contos</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Conto</a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Conto</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <label>Título</label>
          <input type="text" class="form-control" v-model="state.titulo.value" placeholder="Insira um título" />
          <span v-if="state.titulo.error" class="text-danger">Este campo é obrigatório</span>
        </div>
        <div class="col-6">
          <label>URL</label>
          <input type="text" class="form-control" v-model="state.titulo_url.value" placeholder="Insira uma url" />
          <span v-if="state.titulo_url.error" class="text-danger">Este campo é obrigatório</span>
        </div>
        <div class="col-md-5">
          <div class="input_img">
            <label>Imagem</label>
            <input type="file" class="form-control" @change="adicionarImagens" />
            <span v-if="state.erro_imagem" class="text-danger">Este campo é obrigatório</span>
          </div>
        </div>
        <div class="col-md-12" v-if="state.imagens.length > 0">
          <div class="row">
            <div class="col-md-3" v-for="(objImagem, index) in state.imagens" :key="objImagem" style="display: flex">
              <img :src="objImagem.imagem" class="imagem" />
              <button class="btn_deletar_imagem" @click="removerImagem(index)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-x-lg mb-2"
                  viewBox="0 0 16 16">
                  <path
                    d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <label for="texto">Texto do Conto</label>
          <div class="form-group">
            <editor api-key="8rtof9gqqepz37q7viy6i1vme2tv702kdqv8sd5ra7fjr1tr" :init="{
              height: 500,
              menubar: false,
              selector: 'textarea',
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
            }" v-model="state.texto" />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <button class="btn btn_voltar btn-secondary me-3" id="voltar-button" type="submit"
            @click="router.push({ name: 'ContosConta' })">
            Voltar
          </button>
          <button class="btn btn_salvar float-end" id="submit-button" type="submit" @click="salvarConto">
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
import Editor from "@tinymce/tinymce-vue";
export default {
  components: {
    editor: Editor,
  },
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      titulo: {
        value: "",
        error: false,
      },
      titulo_url: {
        value: "",
        error: false,
      },
      status: "ATIVO",
      imagem: {},
      imagens: [],
      erro_imagem: false,
      imagens_deletar: [],
      texto: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchContoById();
      }
    });

    async function fetchContoById() {
      try {
        const { data } = await services.contos.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.titulo.value = data.titulo;
        state.titulo_url.value = data.titulo_url;
        state.status = data.status;
        state.texto = data.texto;
        state.imagens = data.imagens;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarConto() {
      var erro_validacao = false;

      if (state.titulo.value.length == 0) {
        state.titulo.error = true;
        erro_validacao = true;
      }
      if (state.titulo_url.value.length == 0) {
        state.titulo_url.error = true;
        erro_validacao = true;
      }

      if (state.imagens.length == 0) {
        state.erro_imagem = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }

      var conto = {};
      conto.titulo = state.titulo.value;
      conto.titulo_url = state.titulo_url.value;
      conto.texto = state.texto;
      conto.status = state.status;
      if (!state.id) {
        services.contos
          .save({ token, conto })
          .then((data_conto) => {
            for (let i = 0; i < state.imagens.length; i++) {
              var formImagem = new FormData();
              formImagem.append("conto_id", data_conto.data.id);
              formImagem.append("imagem", state.imagens[i].file);
              services.contos
                .salvarImagem({ token, formImagem })
                .then((data) => {
                  console.log(data);
                });
            }
            router.push({ name: "ContosConta" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            valores.forEach((element) => {
              element.forEach((element2) => {
                alert(element2)
              });
            });
          });
      } else {
        console.log("Qtd de imagens para deletar: " + state.imagens_deletar.length);
        if (state.imagens_deletar.length > 0) {
          try {
            const { data } = await services.contos.deletarImagens({
              imagens: state.imagens_deletar,
              token,
            });
            console.log(data);
          } catch (error) {
            console.log(error);
          }
        }
        conto.id = state.id;
        services.contos
          .update({ token, conto })
          .then((data_conto) => {
            for (let i = 0; i < state.imagens.length; i++) {
              if (
                state.imagens[i].file != undefined &&
                state.imagens[i].file != null
              ) {
                var formImagem = new FormData();
                formImagem.append("conto_id", data_conto.data.id);
                formImagem.append("imagem", state.imagens[i].file);
                services.contos
                  .salvarImagem({ token, formImagem })
                  .then((data) => {
                    console.log(data);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            }
            router.push({ name: "ContosConta" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            valores.forEach((element) => {
              element.forEach((element2) => {
                alert(element2);
              });
            });
          });
      }
    }
    async function adicionarImagens(event) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        var objImagem = new Object();
        objImagem.id = index + 1;
        objImagem.file = element;
        objImagem.imagem = URL.createObjectURL(element);
        state.imagens.push(objImagem);
        console.log(objImagem);
      }
    }
    async function removerImagem(index_imagem) {
      if (state.imagens[index_imagem].id != undefined) {
        console.log(state.imagens[index_imagem].id)
        state.imagens_deletar.push(state.imagens[index_imagem].id);
      }
      state.imagens.splice(index_imagem, 1);
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      router,
      state,
      salvarConto,
      adicionarImagens,
      removerImagem,
    };
  },
};
</script> 
<style lang="scss">
/* Basic editor styles */

.ProseMirror {
  margin-top: 10px;
  border: solid 2px #000;
  padding: 10px;
  border-radius: 10px;
  color: #000000;
  min-height: 300px;

  >*+* {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: "JetBrainsMono", monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}

.ProseMirror {
  outline: 0;
}

.btn_editor {
  margin: 5px;
  background: transparent;
  border: solid 2px #000;
  border-radius: 5px;
  color: #000;
}
</style>
<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}

input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}

input:focus {
  border: solid 1px blue;
}

select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}

select:focus {
  border: solid 1px blue;
}

.card {
  min-height: 94.8vh;
}

.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}

#descricao {
  resize: none;
}

.btn_salvar:hover {
  color: #fff;
}

.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
  margin-top: 1rem;
}

.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}

textarea {
  resize: none;
}

.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}

a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}

a:hover {
  color: #93c01f;
}

.imagem {
  width: 200px;
  height: auto;
  object-fit: contain;
  margin-top: 1rem;
}
</style>